import metrics, { IMetric } from 'maps/metrics';

const stream_count_this_week_to_date =
  metrics['stream_count_this_week_to_date'];
const stream_count_last_week_to_date =
  metrics['stream_count_last_week_to_date'];
const stream_wow_in_progress = metrics['stream_wow_in_progress'];
const skiprate_this_week_to_date = metrics['skiprate_this_week_to_date'];
const track_count = metrics['track_count'];
const followers = metrics['followers'];
const position = metrics['position'];
const lastUpdated = metrics['lastUpdated'];

export const defaultOptions = [
  {
    label: `DSP (A-Z)`,
    value: 'customerId',
    key: 'customerId',
    sortOrder: 'asc',
  },
  {
    label: `DSP (Z-A)`,
    value: 'customerId',
    key: 'customerId',
    sortOrder: 'desc',
  },
  {
    label: `Playlist (A-Z)`,
    value: 'displayName',
    key: 'displayName',
    sortOrder: 'asc',
  },
  {
    label: `Playlist (Z-A)`,
    value: 'displayName',
    key: 'displayName',
    sortOrder: 'desc',
  },
];

const options = [
  {
    ...stream_count_this_week_to_date,
    label: 'This Week (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...stream_count_this_week_to_date,
    label: 'This Week (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },
  {
    ...stream_count_last_week_to_date,
    label: 'Last Week (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...stream_count_last_week_to_date,
    label: 'Last Week (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },
  {
    ...stream_wow_in_progress,
    label: 'Week Over Week (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...stream_wow_in_progress,
    label: 'Week Over Week (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },

  {
    ...skiprate_this_week_to_date,
    label: 'Skiprate (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...skiprate_this_week_to_date,
    label: 'Skiprate (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },

  {
    ...track_count,
    label: 'Track Count (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...track_count,
    label: 'Track Count (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },

  {
    ...followers,
    label: 'Followers (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...followers,
    label: 'Followers (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },

  {
    ...position,
    label: 'Position (Low to High)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },
  {
    ...position,
    label: 'Position (High to Low)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
  {
    ...lastUpdated,
    label: 'Last updated (New To Old)',
    withoutSubLabel: true,
    sortOrder: 'desc',
  },
  {
    ...lastUpdated,
    label: 'Last updated (Old To New)',
    withoutSubLabel: true,
    sortOrder: 'asc',
  },
];

export const priorityOption = {
  label: 'Priority Only',
  key: 'priorityOnly',
  value: 'priorityOnly',
  sortOrder: 'asc',
};

/**
 * This function constructs the array needed to populate the
 * sorting metric dropdown on mobile.
 *
 * @param {String} entityType to retrieve the label for entity name column/dropdown option
 * @returns {Array} the options the user can sort by.
 */
const getMobileSortingOptions = (): IMetric[] => options;
export default getMobileSortingOptions;

export const getSelectedMobileOption = (selectedMetric: {
  metricKey: string;
  sortOrder: string;
}): IMetric | undefined => {
  return [...options, ...defaultOptions, priorityOption].find(
    (option: IMetric) =>
      option.key === selectedMetric.metricKey &&
      option.sortOrder === selectedMetric.sortOrder
  );
};
